import { render, staticRenderFns } from "./RemoveAction.vue?vue&type=template&id=274d0975&"
import script from "./RemoveAction.vue?vue&type=script&lang=js&"
export * from "./RemoveAction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports